import React, { useState } from 'react';

export default function ScheduleTransfer() {
  const [form, setForm] = useState({
    recipient: '',
    amount: '',
    frequency: 'Hebdomadaire',
    startDate: '',
  });

  const [scheduledTransfers, setScheduledTransfers] = useState([]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setScheduledTransfers([...scheduledTransfers, form]);
    setForm({ recipient: '', amount: '', frequency: 'Hebdomadaire', startDate: '' });
  };

  return (
    <div className="p-6 space-y-8">
      <h1 className="text-2xl font-bold">Planifiez vos transferts</h1>

      {/* Formulaire de planification */}
      <form onSubmit={handleSubmit} className="space-y-4 bg-white p-6 rounded shadow-md">
        <div>
          <label className="block text-sm font-medium">Destinataire</label>
          <input
            type="text"
            name="recipient"
            value={form.recipient}
            onChange={handleChange}
            className="w-full mt-1 border rounded px-3 py-2"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Montant (USD)</label>
          <input
            type="number"
            name="amount"
            value={form.amount}
            onChange={handleChange}
            className="w-full mt-1 border rounded px-3 py-2"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Fréquence</label>
          <select
            name="frequency"
            value={form.frequency}
            onChange={handleChange}
            className="w-full mt-1 border rounded px-3 py-2"
          >
            <option>Hebdomadaire</option>
            <option>Mensuel</option>
            <option>Trimestriel</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium">Date de début</label>
          <input
            type="date"
            name="startDate"
            value={form.startDate}
            onChange={handleChange}
            className="w-full mt-1 border rounded px-3 py-2"
            required
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Planifier le transfert
        </button>
      </form>

      {/* Liste des transferts planifiés */}
      <div>
        <h2 className="text-xl font-semibold mb-4">Transferts programmés</h2>
        {scheduledTransfers.length === 0 ? (
          <p className="text-gray-500">Aucun transfert programmé pour l'instant.</p>
        ) : (
          <ul className="space-y-2">
            {scheduledTransfers.map((t, index) => (
              <li key={index} className="bg-white p-4 rounded shadow">
                <p><strong>Destinataire :</strong> {t.recipient}</p>
                <p><strong>Montant :</strong> {t.amount} USD</p>
                <p><strong>Fréquence :</strong> {t.frequency}</p>
                <p><strong>Date de début :</strong> {t.startDate}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
